import styled from "styled-components";
import { BOX_SHADOW, PRIMARY, SECONDARY } from "../const/colors";
import { mobile_medium, mobile_normal, mobile_title_big } from "../const/fonts";

export const Container = styled.div`
  min-height: 100vh;
  width: 100vw;
  max-width: 2000px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    padding-top: 80px;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  padding: 2rem 7%;
  margin-bottom: 2rem;

  input, textarea {
    transition: all 0.3s ease;
    &:hover {
      border-color: #fff;
    }
  }

  @media screen and (max-width: 1400px) {
    padding: 2rem 1%;
  }
  @media screen and (max-width: 1200px) {
    padding: 2rem 10%;
    grid-template-columns: 1fr;
  }
  @media screen and (max-width: 900px) {
    padding: 2rem 6%;
  }
  @media screen and (max-width: 768px) {
    padding: 2rem 2%;
  }
  @media screen and (max-width: 480px) {
    padding: 0 2%;
  }

`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 3rem;

  @media screen and (max-width: 1400px) {
    padding: 1rem 2rem;
  }
  @media screen and (max-width: 480px) {
    padding: 1rem;
  }
`;

export const FormTitle = styled.div`
    color: #fff;
    margin-bottom: 3rem;
    text-align: center;
  > h2 {
    padding: 1rem;
    font-weight: 900;
  }
  > h3 {
    padding: 1rem;
    font-size: 1rem;
  }

  p span {
    color: ${PRIMARY};
  }

  @media screen and (max-width: 768px) {
    > h2 {
      font-size: ${mobile_title_big};
    }
  }
  @media screen and (max-width: 480px) {
    > h2 {
      font-size: 18px;
    }
    p{
      font-size: 0.9rem;
    }
    margin-bottom: 1rem;
  }
`;

export const Form = styled.form``;

export const FormRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-bottom: 0;
  }

`;

export const FormItem = styled.div`
  display: flex;
  flex-direction: column;
  flex:1;
  margin: 0 0.5rem;
   label {
    color: #fff;
    font-weight: bold;
   // padding: 0.2rem 0.8rem;
    font-size: 1.1rem;
  }

  > label {
    padding: 0.2rem 0.8rem;
    text-transform: uppercase;
  }
  


  > div button {
    height: 39px;
  }
  p {
    color: #fff;
    font-size: 0.8rem;
    margin: 0.5rem 1rem;
  }
  > input {
    border: 1px solid ${PRIMARY};
    outline: none;
    background-color: transparent;
    color: #fff;
    padding: 0.8rem;
    font-size: 1.1rem;
    ::placeholder {
      color: #888;
    }
  }

  @media screen and (max-width: 2000px) {
     label, > input {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    margin: 1rem 0;
    > div button {
      height: 40.5px;
    }

    > input::placeholder {
      text-align: center;
    } 

    label, input {
      font-size: ${mobile_normal};
    }
  }

  @media screen and (max-width: 480px) {
    label,  input {
      font-size: 0.9rem;
    }
}

`;

export const FormCheckBox = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  margin: 1rem 0.5rem;

  > label {
    font-size: 1.2rem;
  }
  > label.title {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.8rem;
  }
  label.form-control {
    display: grid;
    grid-template-columns: 1em auto;
    gap: 0.5em;
    margin: 0.5rem;
    font-size: 1.1rem;
    width: fit-content;
  }
  @media screen and (max-width: 2000px) {
    label.form-control, label {
      font-size: 0.9rem;
    }
  }
  @media screen and (max-width: 768px) {
    label.form-control, label {
      font-size: ${mobile_normal};
    }
  }
`;

export const FormMessage = styled.div`
  display: flex;
  flex-direction: column;

  > label {
    color: #fff;
    font-weight: bold;
    padding: 0.2rem 0.8rem;
    font-size: 1.1rem;
    text-transform: uppercase;
  }

  > textarea {
    border: 1px solid ${PRIMARY};
    outline: none;
    background-color: transparent;
    color: #fff;
    padding: 0.8rem;
    resize: none;
    height: 150px;
    font-size: 1.1rem;
    ::placeholder {
      color: #888;
    }
  }

  @media screen and (max-width: 2000px) {
    label, textarea {
      font-size: 0.8rem;
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    margin: 1rem 0;

    > label, textarea::placeholder {
      text-align: center;
    }

    label, textarea {
      font-size: ${mobile_normal};
    }
  }
`;

export const FormTermsAndConditions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0;
  label {
    display: grid;
    grid-template-columns: 1em auto;
    gap: 0.5em;
    margin: 0.5rem;
    color: #fff;
    font-size: 1rem;
  }

  @media screen and (max-width: 2000px) {
    label {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 768px) {
    label {
      font-size: ${mobile_medium};
    }
  }

`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`
export const ButtonSend = styled.button`
  font-size: 1.1rem;
  min-width: 300px;
  font-weight: 600;
  margin: 2rem auto;
	border: none;
  background-color: ${PRIMARY};
  color: ${SECONDARY};
  box-shadow: ${BOX_SHADOW};
  padding: 0.7rem 1.5rem;
  cursor: pointer;
  transition: all .3s ease-in-out;

  &:disabled {
    cursor: progress;
    opacity: 0.8;
    box-shadow: none;
  }
  &:hover:not(:disabled){
    background-color: #fff;
    transform: scale(1.05);
  }

  @media screen and (max-width: 2000px) {
      font-size: 0.9rem;
  }
  @media screen and (max-width: 768px) {
      font-size: ${mobile_normal}
  }

`;

export const ImgContainer = styled.div`
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 1200px) {
    display: none;
  }
`;

export const MapContainer = styled.div`
  //width: 100vw;
  height: 400px;

  > .frame {
    width: 100%;
    height: 100%;
  }
`;